/**
 * API клієнт для ref.trade_equipment (Фаза 2.1 #1).
 * Backend: /api/v1/refs/trade-equipment. Permission: refs.trade_equipment.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export type EquipmentType = 'scale' | 'scanner' | 'printer' | 'cash_drawer' | 'other';

export interface TradeEquipment {
  id: string;
  organization_id: string;
  code: string | null;
  name: string;
  equipment_type: EquipmentType;
  serial_number: string | null;
  pos_workstation_id: string | null;
  is_active: boolean;
  deletion_mark: boolean;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface TradeEquipmentCreate {
  organization_id: string;
  code?: string | null;
  name: string;
  equipment_type: EquipmentType;
  serial_number?: string | null;
  pos_workstation_id?: string | null;
  is_active?: boolean;
  comment?: string | null;
}

export type TradeEquipmentUpdate = Partial<Omit<TradeEquipmentCreate, 'organization_id'>>;

export const refsTradeEquipment = {
  list: (params?: {
    organization_id?: string;
    equipment_type?: EquipmentType;
    pos_workstation_id?: string;
    is_active?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<TradeEquipment>>('/refs/trade-equipment', { params }).then((r) => r.data),
  get: (id: string) => api.get<TradeEquipment>(`/refs/trade-equipment/${id}`).then((r) => r.data),
  create: (payload: TradeEquipmentCreate) =>
    api.post<TradeEquipment>('/refs/trade-equipment', payload).then((r) => r.data),
  update: (id: string, payload: TradeEquipmentUpdate) =>
    api.patch<TradeEquipment>(`/refs/trade-equipment/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/refs/trade-equipment/${id}`).then(() => undefined),
};
